import { useDateParam } from "@/hooks/useSkipassFlow"
import { getIsSummer } from "@/utils/getSeason"

const useIsSummer = () => {
  const { startDate } = useDateParam()
  return getIsSummer(startDate)
}

export default useIsSummer
